import React from 'react';
import './ChatOptionList.css';

export interface ChatOptionListProps {
  options: Array<{
    id: string;
    label: string;
    value: string;
    isSelected?: boolean;
    disabled?: boolean;
  }>;
  onOptionSelect: (option: { id: string; label: string; value: string }) => void;
  allowMultipleSelection?: boolean;
  className?: string;
}

export const ChatOptionList: React.FC<ChatOptionListProps> = ({
  options,
  onOptionSelect,
  allowMultipleSelection = false,
  className = '',
}) => {
  const handleOptionClick = (option: { id: string; label: string; value: string }) => {
    if (!option.disabled) {
      onOptionSelect(option);
    }
  };

  return (
    <div className={`chat-option-list ${className}`}>
      {options.map((option) => (
        <button
          key={option.id}
          className={`chat-option-item ${
            option.isSelected ? 'selected' : ''
          } ${option.disabled ? 'disabled' : ''}`}
          onClick={() => handleOptionClick(option)}
          disabled={option.disabled}
          aria-pressed={option.isSelected}
          type="button"
        >
          <span className="chat-option-label">{option.label}</span>
        </button>
      ))}
    </div>
  );
};

export default ChatOptionList;
